(() => {
  if (window.__naturalHeaderFixLoaded) return;
  window.__naturalHeaderFixLoaded = true;
  const ready = (callback) => document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", callback, { once: true }) : callback();
  ready(() => {
    document.querySelectorAll("[data-account-link]").forEach((link) => {
      if (link.dataset.naturalAccountBound === "true") return;
      link.dataset.naturalAccountBound = "true";
      link.addEventListener("click", (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === "_blank") return;
        const panel = document.querySelector("[data-account-loading]");
        if (!panel) return;
        event.preventDefault();
        panel.hidden = false;
        requestAnimationFrame(() => panel.classList.add("is-visible"));
        setTimeout(() => { window.location.href = link.href; }, 180);
      });
    });
    document.querySelectorAll("[data-search-panel]").forEach((panel) => {
      if (panel.dataset.naturalSearchBound === "true") return;
      panel.dataset.naturalSearchBound = "true";
      const header = panel.closest(".site-header") || document;
      const toggle = header.querySelector("[data-search-toggle]");
      const closeButton = panel.querySelector("[data-search-close]");
      const input = panel.querySelector("[data-search-input]");
      const results = panel.querySelector("[data-search-results]");
      const status = panel.querySelector("[data-search-status]");
      const form = panel.querySelector("[data-search-form]");
      const rawUrl = panel.dataset.predictiveSearchUrl || "/search/suggest";
      const suggestUrl = rawUrl.endsWith(".json") ? rawUrl : `${rawUrl}.json`;
      let timer;
      let controller;
      if (!toggle || !input || !results || !status || !form) return;
      const esc = (value) => String(value || "").replace(/[&<>"']/g, (char) => ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[char] || char));
      const clean = (value) => String(value || "").replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
      const price = (value) => {
        const number = Number.parseFloat(value);
        if (Number.isNaN(number)) return "";
        return number.toLocaleString("de-DE", { style: "currency", currency: "EUR" });
      };
      const open = () => {
        panel.hidden = false;
        toggle.setAttribute("aria-expanded", "true");
        requestAnimationFrame(() => panel.classList.add("is-open"));
        setTimeout(() => input.focus(), 50);
      };
      const close = () => {
        panel.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
        setTimeout(() => { if (!panel.classList.contains("is-open")) panel.hidden = true; }, 180);
      };
      const render = (data, query) => {
        const resources = data?.resources?.results || {};
        const groups = [["products", "Products"], ["pages", "Pages"], ["articles", "Journal"], ["collections", "Collections"]];
        const html = groups.map(([key, label]) => {
          const items = Array.isArray(resources[key]) ? resources[key] : [];
          if (!items.length) return "";
          return `<div class="header-search-group"><p>${label}</p>${items.slice(0, 4).map((item) => {
            const image = item?.featured_image?.url || item?.image;
            const description = esc(clean(item.summary_html || item.body).slice(0, 96));
            const itemPrice = key === "products" && item?.price ? price(item.price) : "";
            return `<a class="header-search-result" href="${esc(item.url || `/search?q=${encodeURIComponent(query)}`)}">${image ? `<span class="header-search-result-image"><img src="${esc(image)}" alt="${esc(item.title)}" loading="lazy"></span>` : `<span class="header-search-result-mark">${esc(label[0])}</span>`}<span class="header-search-result-copy"><strong>${esc(item.title)}</strong>${description ? `<small>${description}</small>` : ""}</span>${itemPrice ? `<span class="header-search-result-price">${itemPrice}</span>` : ""}</a>`;
          }).join("")}</div>`;
        }).join("");
        status.textContent = html ? "Search results" : "No results yet. Try mineral, reef, sunscreen or brand.";
        results.innerHTML = html ? `${html}<a class="header-search-all" href="/search?q=${encodeURIComponent(query)}">View all results</a>` : "";
      };
      const search = (query) => {
        const term = query.trim();
        clearTimeout(timer);
        if (term.length < 2) {
          if (controller) controller.abort();
          status.textContent = "Start typing to search.";
          results.innerHTML = "";
          return;
        }
        status.innerHTML = '<span class="mini-spinner" aria-hidden="true"></span> Searching';
        timer = setTimeout(async () => {
          try {
            if (controller) controller.abort();
            controller = new AbortController();
            const url = `${suggestUrl}?q=${encodeURIComponent(term)}&resources[type]=product,page,article,collection&resources[limit]=6`;
            const response = await fetch(url, { headers: { Accept: "application/json" }, signal: controller.signal });
            if (!response.ok) throw new Error("Search failed");
            render(await response.json(), term);
          } catch (error) {
            if (error.name === "AbortError") return;
            status.textContent = "Search is taking a moment. Press enter to view all results.";
          }
        }, 180);
      };
      toggle.addEventListener("click", () => panel.hidden || !panel.classList.contains("is-open") ? open() : close());
      closeButton?.addEventListener("click", close);
      input.addEventListener("input", () => search(input.value));
      form.addEventListener("submit", () => { if (!input.value.trim()) input.value = ""; });
      document.addEventListener("click", (event) => {
        const target = event.target;
        if (panel.hidden || !(target instanceof Node) || panel.contains(target) || toggle.contains(target)) return;
        close();
      });
      document.addEventListener("keydown", (event) => {
        if (event.key !== "Escape" || panel.hidden) return;
        close();
        toggle.focus();
      });
    });
  });
})();

// NATUERLICH brand-name wordmark normalization
(() => {
  if (window.__naturalBrandNameStyleLoaded) return;
  window.__naturalBrandNameStyleLoaded = true;

  const ready = (callback) => {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback, { once: true });
    } else {
      callback();
    }
  };

  const pattern = /NATÜRLICH|Natürlich/g;
  const skipSelector = ".natuerlich-brand-wordmark, script, style, noscript, textarea, input, select, option, code, pre, svg, canvas";

  const isEligibleParent = (parent) => {
    if (!parent || typeof parent.closest !== "function") return false;
    return !parent.closest(skipSelector);
  };

  const normalizeTextNode = (node) => {
    const text = node.nodeValue || "";
    pattern.lastIndex = 0;
    if (!pattern.test(text) || !isEligibleParent(node.parentElement)) return;

    pattern.lastIndex = 0;
    const fragment = document.createDocumentFragment();
    let lastIndex = 0;
    text.replace(pattern, (match, offset) => {
      if (offset > lastIndex) {
        fragment.appendChild(document.createTextNode(text.slice(lastIndex, offset)));
      }
      const wordmark = document.createElement("span");
      wordmark.className = "natuerlich-brand-wordmark";
      wordmark.textContent = "NATÜRLICH";
      fragment.appendChild(wordmark);
      lastIndex = offset + match.length;
      return match;
    });
    if (lastIndex < text.length) {
      fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
    }
    node.parentNode.replaceChild(fragment, node);
  };

  const normalizeRoot = (root) => {
    if (!root) return;
    if (root.nodeType === 3) {
      normalizeTextNode(root);
      return;
    }
    if (![1, 9, 11].includes(root.nodeType)) return;
    if (root.nodeType === 1 && !isEligibleParent(root)) return;

    const nodes = [];
    const walker = document.createTreeWalker(root, 4, {
      acceptNode(node) {
        pattern.lastIndex = 0;
        if (!pattern.test(node.nodeValue || "")) return 2;
        if (!isEligibleParent(node.parentElement)) return 2;
        return 1;
      }
    });

    let node;
    while ((node = walker.nextNode())) nodes.push(node);
    nodes.forEach(normalizeTextNode);
  };

  ready(() => {
    normalizeRoot(document.body);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => normalizeRoot(node));
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
